// extracted by mini-css-extract-plugin
export default {"subtitle":"SectionSubtitle-module__subtitle"};